import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A container component that controls the opacity of its children.
 *
 * @remarks
 * This component allows for smooth opacity transitions based on the show prop.
 * Useful for fade-in/fade-out effects without affecting layout.
 *
 * @param props - The component props
 * @param props.children - The child elements to display
 * @param props.show - Controls opacity: true = opacity 1, false = opacity 0
 * @param props.transition - Whether to animate opacity changes (default: true)
 *
 * @example
 * ```tsx
 * <OpacityContainer show={isVisible}>
 *   <div>This content will fade in/out</div>
 * </OpacityContainer>
 * ```
 *
 * @example
 * ```tsx
 * <OpacityContainer show={isVisible} transition={false}>
 *   <div>This content will appear/disappear instantly</div>
 * </OpacityContainer>
 * ```
 *
 * @returns A div element with controlled opacity
 */
import './OpacityContainer.css';
export const OpacityContainer = ({ children, show, transition = true }) => {
    const className = `opacityContainer ${transition ? 'opacityContainerTransition' : ''}`;
    const style = { opacity: show ? 1 : 0 };
    return (_jsx("div", { className: className, style: style, children: children }));
};
